import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { mainRoutes } from './main.routing';
import { LayoutModule } from './shared/layout/layout.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(mainRoutes),
        LayoutModule
    ],
    declarations: [
        DashboardComponent
    ],
    exports: [
    ],
    providers: []
})
export class MainModule { }
